import { connect } from "react-redux"

import BulkActionsSidebar from "app/static/frontend/search-new/components/BulkActions/sidebar/BulkActionsSidebar"

import { updateSidebarButton } from "shared/search/searchify/bulkactions/action-creators"
import { selectBulkActionsActiveSidebarButton, selectBulkActionsValidOptions } from "shared/search/searchify/bulkactions/selectors"

const mapStateToProps = (state, props) => ({
    activeSidebarButton: selectBulkActionsActiveSidebarButton(state, props),
    bulkActionValidOptions: selectBulkActionsValidOptions(state, props),
})

const mapDispatchToProps = {
    updateSidebarButton
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsSidebar)
